import React, { useEffect, useState } from 'react';
import { Input, InputNumber } from '../../../components/ui/Input';
import SearchableSelect from '../../../components/ui/SearchableSelect'; // <-- ajuste o path se necess�rio
import Title from '../../../components/ui/Title';
import { useRedux } from '../../../redux/hook/useRedux';
import { actionTypeBenefitUser } from '../../../redux/user/actions';

const IdentityDetails = ({ identityDetails }) => {
    const { identityErrors, identityInputs } = identityDetails;
    const { dispatch } = useRedux();
    const [typeBenefits, setTypeBenefits] = useState([]);
    const [selectedTypeBenefit, setSelectedTypeBenefit] = useState(null);

    useEffect(() => {
        dispatch(
            actionTypeBenefitUser((types) => {
                setTypeBenefits(types || []);
            })
        );
    }, [dispatch]);

    useEffect(() => {
        const selectInput = identityInputs.find((i) => i.type === 'select');
        if (!selectInput) return;

        const currentValue = selectInput.value ?? null;

        if (currentValue == null) {
            setSelectedTypeBenefit(null);
            return;
        }

        if (typeBenefits.length > 0) {
            const opt =
                typeBenefits
                    .map((x) => ({ value: x.codigo, label: x.descricao }))
                    .find((o) => String(o.value) === String(currentValue)) ||                
                { value: currentValue, label: String(currentValue) };

            setSelectedTypeBenefit(opt);
        }
    }, [identityInputs, typeBenefits]);

    return (
        <>
            <Title text1="Dados" text2="Pessoais" />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-5">
                {identityInputs.map((input, i) => {
                    const fieldName = input.name;
                    const error = identityErrors[fieldName];

                    return (
                        <div key={i}>
                            {input.type === 'number' && (
                                <InputNumber
                                    type={input.type}
                                    label={input.label}
                                    placeholder={input.placeholder}
                                    value={input.value}
                                    onChange={input.onChange}
                                    className={input.className}
                                    name={input.name}
                                />
                            )}

                            {input.type === 'text' && (
                                <Input
                                    type={input.type}
                                    label={input.label}
                                    placeholder={input.placeholder}
                                    value={input.value}
                                    onChange={input.onChange}
                                    className={input.className}
                                    name={input.name}
                                    maxLength={input.maxLength}
                                />
                            )}

                            {input.type === 'select' && (
                                <SearchableSelect
                                    label="Tipo de Beneficio"
                                    options={typeBenefits.map((x) => ({
                                        value: x.codigo,
                                        label: x.descricao,
                                    }))}
                                    value={selectedTypeBenefit}
                                    onChange={(option) => {
                                        setSelectedTypeBenefit(option);
                                        if (typeof input.onChange === 'function') {
                                            input.onChange({
                                                target: { name: input.name, value: option?.value ?? null },
                                            });
                                        }
                                    }}
                                    className="w-full"
                                />
                            )}

                            {error && (
                                <span className="w-full text-start text-red-500 text-sm">
                                    {error}
                                </span>
                            )}
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default IdentityDetails;
